import { render, staticRenderFns } from "./AdSetLimits.vue?vue&type=template&id=5edac691&"
import script from "./AdSetLimits.vue?vue&type=script&lang=ts&"
export * from "./AdSetLimits.vue?vue&type=script&lang=ts&"
import style0 from "./AdSetLimits.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports